@let isDesktopMode = isDesktopMode$ | async;

<header cabHeader [isDesktopMode]="isDesktopMode"></header>
<main class="main">
  <router-outlet></router-outlet>
</main>
<footer cabFooter [isDesktopMode]="isDesktopMode"></footer>
